import React from "react";
import { useSelector } from "react-redux";

import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { dateFormat } from "../../../exports/GlobalFunctions";
import TableSkeleton from "../../common-components/TableSkeleton";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const AllKeywords = ({
  allKeyData,
  setAllKeyData,
  setModValues,
  onClickEdit,
  handleDeleteKeyword,
}) => {
  const { keywordLoading } = useSelector((state) => state.api);

  const tbColumn = [
    {
      dataField: "tab_name",
      text: "Tab Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.tab_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "predefined_msg",
      text: "Message",
      formatter: (_, row) => {
        return (
          <>
            {row?.predefined_msg?.length <= 30 ? (
              <span className="tb-data minWidth150">{row.predefined_msg}</span>
            ) : (
              <span
                className="tb-data minWidth150"
                style={{ cursor: "pointer" }}
              >
                {row?.predefined_msg?.substring(0, 90)}{" "}
                <b
                  className="link"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "description",
                      rowData: row,
                    }))
                  }
                >
                  ...Read More
                </b>
              </span>
            )}
          </>
        );
      },
    },
    {
      dataField: "sheet_name",
      text: "Sheet Name/ID",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth100 link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "sheet_id",
                rowData: row,
              }))
            }
          >
            {row?.sheet_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "lead_capture",
      text: "Add To Raw Lead",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.lead_capture === "true" && row?.lead_capture !== "null" ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? dateFormat(row.date_added) : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background: row?.status === "active" ? "#B4E7B9" : "#F3DADA",
              color: row?.status === "active" ? "#0A701B" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={(e) => {
              onClickEdit(e, row);

              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "edit",
                rowData: row,
              }));
            }}
            style={{ border: "none", cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>
          <button
            className="actionBtn icon delete"
            onClick={(e) => {
              handleDeleteKeyword(e, row?.uid);
            }}
            style={{ border: "none", cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-archive-fill"
              viewBox="0 0 16 16"
            >
              <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1M.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8z" />
            </svg>
          </button>
          <button
            className="actionBtn icon copy"
            onClick={(e) => {
              onClickEdit(e, row);

              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "copy",
                rowData: row,
              }));
            }}
            style={{ border: "none", cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-copy"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {keywordLoading ? (
        <TableSkeleton />
      ) : (
        <div className="subscriptionTbContainer separatedTable mt15">
          <PaymentLinkTable
            tableData={allKeyData.allKeywords}
            tableColumns={tbColumn}
            tablePagination={allKeyData.pagination}
            isPage={allKeyData.isPage}
            setIsPage={(value) =>
              setAllKeyData((prevData) => ({
                ...prevData,
                isPage: value,
              }))
            }
          />
        </div>
      )}
    </>
  );
};

export default AllKeywords;
